import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/icons/borrowed.svg'
import _imports_1 from '@/assets/icons/assigned.svg'
import _imports_2 from '@/assets/icons/pagefirstenabled.svg'
import _imports_3 from '@/assets/icons/pagefirstdisabled.svg'
import _imports_4 from '@/assets/icons/pagelastenabled.svg'
import _imports_5 from '@/assets/icons/pagelastdisabled.svg'


const _hoisted_1 = { key: 1 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = { class: "expiration-cell" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "borrowcell" }
const _hoisted_7 = {
  key: 0,
  src: _imports_0,
  style: {"width":"25px"},
  alt: "borrowediconimg",
  title: "borrowediconimg"
}
const _hoisted_8 = {
  key: 1,
  src: _imports_1,
  style: {"width":"25px"},
  alt: "assignediconimg",
  title: "assignediconimg"
}
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { key: 3 }
const _hoisted_11 = {
  key: 1,
  class: "pagingdiv"
}
const _hoisted_12 = { class: "pagelabel" }
const _hoisted_13 = {
  key: 0,
  src: _imports_2,
  style: {"width":"20px"},
  alt: "pagefirstenabledimg",
  title: "pagefirstenabledimg"
}
const _hoisted_14 = {
  key: 1,
  src: _imports_3,
  style: {"width":"20px"},
  alt: "pagefirstdisabledimg",
  title: "pagefirstdisabledimg"
}
const _hoisted_15 = {
  key: 0,
  src: _imports_4,
  style: {"width":"20px"},
  alt: "pagelastenabledimg",
  title: "pagelastenabledimg"
}
const _hoisted_16 = {
  key: 1,
  src: _imports_5,
  style: {"width":"20px"},
  alt: "pagelastdisabledimg",
  title: "pagelastdisabledimg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.showSubscription)
      ? _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          key: 0,
          ref: "assignedUserstbl",
          id: "assignedusertable",
          data: _ctx.usersList,
          "max-height": "500",
          "scrollbar-always-on": "",
          "header-cell-style": _ctx.headerstyle,
          "row-style": _ctx.rowdatastyle,
          onSelectionChange: _ctx.handleSelectionChange,
          "row-class-name": _ctx.rowDisableWithStatus,
          "cell-class-name": _ctx.disableCellWithCheckedout,
          "empty-text": "No users assigned",
          class: "topmargin"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              type: "selection",
              width: "50"
            }),
            _createVNode(_component_el_table_column, { label: "User Name" }, {
              default: _withCtx((scope) => [
                (scope.row.status === 'Checked-out')
                  ? (_openBlock(), _createBlock(_component_el_tooltip, {
                      key: 0,
                      placement: "top"
                    }, {
                      content: _withCtx(() => [
                        _createTextVNode("The license is borrowed, so assignment cannot be remove ")
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", null, _toDisplayString(scope.row.userName), 1)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true),
                (scope.row.status !== 'Checked-out')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(scope.row.userName), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Email",
              prop: "email"
            }),
            _createVNode(_component_el_table_column, {
              align: "center",
              label: "License End Date"
            }, {
              default: _withCtx((props) => [
                (_ctx.checkExpirationDate(props.row.expirationDateTime))
                  ? (_openBlock(), _createBlock(_component_el_tooltip, {
                      key: 0,
                      placement: "top"
                    }, {
                      content: _withCtx(() => [
                        (_ctx.expiringIn30Days)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                              _createTextVNode(" The license has expired or is about to expire shortly. "),
                              _hoisted_3,
                              _createTextVNode("Please unassign the expired license and assign the new license. ")
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_4, _toDisplayString(props.row.expirationDate), 1)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true),
                (!_ctx.checkExpirationDate(props.row.expirationDateTime))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(props.row.expirationDate), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Maintenance Renewal Date",
              prop: "maintenanceRenewalDateFormatted"
            }),
            _createVNode(_component_el_table_column, {
              label: "Add-on",
              align: "center",
              prop: "addOns"
            }, {
              default: _withCtx((props) => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row.addOns, (addon, index) => {
                  return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(addon.productName), 1))
                }), 128))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              align: "center",
              label: "Status",
              prop: "status"
            }, {
              default: _withCtx((user) => [
                _createElementVNode("div", _hoisted_6, [
                  (user.row.status === 'Checked-out')
                    ? (_openBlock(), _createElementBlock("img", _hoisted_7))
                    : _createCommentVNode("", true),
                  (user.row.status === 'Assigned')
                    ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                    : _createCommentVNode("", true),
                  (user.row.status === 'Checked-out')
                    ? (_openBlock(), _createElementBlock("label", _hoisted_9, " Borrowed"))
                    : _createCommentVNode("", true),
                  (user.row.status === 'Assigned')
                    ? (_openBlock(), _createElementBlock("label", _hoisted_10, _toDisplayString(user.row.status), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data", "header-cell-style", "row-style", "onSelectionChange", "row-class-name", "cell-class-name"])), [
          [_directive_loading, _ctx.loading]
        ])
      : _createCommentVNode("", true),
    (_ctx.totalPages > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("label", _hoisted_12, [
            _createElementVNode("strong", null, "Page " + _toDisplayString(_ctx.currentPage) + " / " + _toDisplayString(_ctx.totalPages), 1)
          ]),
          _createVNode(_component_el_button, {
            plain: "",
            class: "paginationbtn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.currentPage = 1)),
            id: "fiestpage",
            disabled: _ctx.currentPage === 1
          }, {
            default: _withCtx(() => [
              (_ctx.currentPage !== 1)
                ? (_openBlock(), _createElementBlock("img", _hoisted_13))
                : _createCommentVNode("", true),
              (_ctx.currentPage === 1)
                ? (_openBlock(), _createElementBlock("img", _hoisted_14))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_pagination, {
            layout: "prev, next",
            total: _ctx.totalRowsCount,
            "page-size": 10,
            "current-page": _ctx.currentPage,
            "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentPage) = $event))
          }, null, 8, ["total", "current-page"]),
          _createVNode(_component_el_button, {
            plain: "",
            class: "paginationbtn",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.currentPage = _ctx.totalPages)),
            id: "lastpage",
            disabled: _ctx.currentPage === _ctx.totalPages
          }, {
            default: _withCtx(() => [
              (_ctx.currentPage !== _ctx.totalPages)
                ? (_openBlock(), _createElementBlock("img", _hoisted_15))
                : _createCommentVNode("", true),
              (_ctx.currentPage === _ctx.totalPages)
                ? (_openBlock(), _createElementBlock("img", _hoisted_16))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}